import { render, staticRenderFns } from "./NavigationLink.vue?vue&type=template&id=192dad53&"
import script from "./NavigationLink.vue?vue&type=script&lang=js&"
export * from "./NavigationLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports